import React from "react";

import {
    GridWrapper,
    CardGrid,
    Card,
    Header,
    HeaderLeft,
    HeaderRight,
    Line,
    StatusBadge,
    ActionDot,
    Divider,
    Section,
    Label,
    Input,
    Chips,
    Chip,
    Pagination,
    Summary,
    Pages,
    Page,
    Rows,
} from "./GatewayShimmer.styles";

const CARD_COUNT = 6;
const CHIP_COUNT = 3;
const PAGE_COUNT = 4;

// Mirrors the three text lines in GatewayCard's HeaderLeft
const HEADER_LINES: ReadonlyArray<{ width: string; height?: number }> = [
    { width: "55%", height: 14 }, // site / title
    { width: "70%", height: 12 }, // company
    { width: "80%", height: 12 }, // coreDeviceThingName
];

const GatewayShimmer: React.FC = () => (
    <GridWrapper>
        <CardGrid>
            {Array.from({ length: CARD_COUNT }, (_, cardIndex) => (
                <Card key={cardIndex}>
                    {/* ── Header – mirrors GatewayCard Header ── */}
                    <Header>
                        <HeaderLeft>
                            {HEADER_LINES.map(({ width, height }) => (
                                <Line key={width} width={width} height={height} />
                            ))}
                        </HeaderLeft>
                        <HeaderRight>
                            <StatusBadge />
                            <ActionDot />
                        </HeaderRight>
                    </Header>

                    <Divider />

                    {/* ── LinkedDevices section ── */}
                    <Section>
                        <Label />
                        <Input />
                    </Section>

                    <Divider />

                    {/* ── DataPrivacySettings section ── */}
                    <Section>
                        <Label />
                        <Chips>
                            {Array.from({ length: CHIP_COUNT }, (_chip, chipIndex) => (
                                <Chip key={chipIndex} />
                            ))}
                        </Chips>
                    </Section>
                </Card>
            ))}
        </CardGrid>
        <Pagination>
            <Summary />
            <Pages>
                {Array.from({ length: PAGE_COUNT }, (_page, pageIndex) => (
                    <Page key={pageIndex} />
                ))}
            </Pages>
            <Rows />
        </Pagination>
    </GridWrapper>
);

export default React.memo(GatewayShimmer);
